import { useLocation, useParams } from 'router-v6'

/**
 * Hook to get flow ID from route.
 *
 * `isNew` is derived from the `?new` search param. Stripped after first save.
 * `isFromOnboarding` is derived from the `?onb=<source>` param that the
 * onboarding banners append when they open the builder, marking the session as
 * onboarding-launched. It does NOT affect vibe-agent availability — the feature
 * flags alone decide that (use-vibe-agent-gate.ts). Stripped alongside `?new`
 * after the first save.
 */
export const useFlowId = () => {
  const { id } = useParams()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const isNew = searchParams.has('new')
  const isFromOnboarding = searchParams.has('onb')

  return {
    id,
    isNew,
    isFromOnboarding,
  }
}
